<script lang="ts">
	//# SVELTE
	import { onMount } from 'svelte';
	//# Modules
	import { push, querystring, replace } from 'svelte-spa-router';
	import { format } from 'svelte-i18n';

	//# Helpers
	import { capFirstChar } from 'src/helpers/utilities';

	//# Design system components
	import { ButtonV2, Text, AlertV2 } from '@Shelly/shelly-design-system';

	//# Internal components
	import DeleteAccountModal from './DeleteAccountModal.svelte';
	import RequestDeleteAccountModalV2 from './RequestDeleteAccountModalV2.svelte';

	const searchParams = new URLSearchParams($querystring);

	let showModal = false;
	let loading = false;
	let alertError = '',
		email = searchParams.get('email') || '',
		token = searchParams.get('token') || '',
		inst = 'https://' + searchParams.get('inst') || '';

	$: disableResetPasswordForm = alertError !== '' || false;
	$: alertErrorMessage = alertError
		? alertError
		: disableResetPasswordForm
			? $format('alert_error_missing_token_data', {
					default: 'Missing token data!',
				})
			: '';

	onMount(() => {
		if (!$querystring.includes('email=')) {
			console.error('missing email data', $querystring);
		}
		if (!$querystring.includes('inst=')) {
			console.error('missing instance data', $querystring);
		}
		if (!$querystring.includes('token=')) {
			disableResetPasswordForm = true;
		}
	});

	const callbackSuccess = () => {
		showModal = false;
		replace('/login');
	};

	const callbackError = (error) => {
		showModal = false;
		alertError = error;
	};
</script>

<Text element="h1" class="text-capitalize mb-l pl-s">
	{$format('title_delete_account', { default: 'delete account' })}
</Text>

{#if disableResetPasswordForm || alertError !== ''}
	<div class="mb-m">
		<AlertV2
			type="danger"
			heading={$format('alert_error_on_', {
				default: 'Error on deleting account!',
			})}
			isHeadingBold
			message={alertErrorMessage}
			cta={{
				title: $format('alert_link_delete_account', {
					default: 'Send a new account deletion request',
				}),
			}}
			on:cta_click={() => {
				push('/request-account-delete');
				alertError = 'Delete account';
			}}
		/>
	</div>
{/if}

<ButtonV2
	variant="danger"
	{loading}
	disabled={loading || disableResetPasswordForm}
	class="mb-m"
	width="full"
	on:click={() => {
		showModal = true;
	}}
>
	{capFirstChar($format('button_delete_account', { default: 'delete account' }))}
</ButtonV2>

<ButtonV2
	variant="secondary"
	{loading}
	width="full"
	on:click={() => {
		alertError = '';
		replace('/login');
	}}>{capFirstChar($format('button_cancel', { default: 'cancel' }))}</ButtonV2
>

<RequestDeleteAccountModalV2
	{inst}
	{token}
	bind:showModal
	bind:loading
	{callbackSuccess}
	{callbackError}
/>
